import {CITY_HEX_TOKENS} from "../../constants/tokens";
import {addAllToSet} from "../other/addAllToSet";

export const getCityHexKeys = (city) => {
  const hexKeys = new Set([city.centralQuarter]);

  Object.values(CITY_HEX_TOKENS).forEach(value => {
    const cityKeys = city[value];
    if(cityKeys) {
      addAllToSet(hexKeys, ...cityKeys)
    }
  });

  return hexKeys;
};
